<template>
    <div class="user-list">
        <div class="d-flex justify-content-between align-items-center mb-4">
            <h2 class="mb-0">{{ $t('customer.title') }}</h2>
        </div>

        <CrudTable :columns="fields" :data-sources="customers" :pagination="paginationInfo" :loader="isLoading"
            list-url="/admin/customers" @search="handleSearch" @filter="handleFilter" @refresh="fetchLocations">
            <!-- Status Badge Column -->

            <template #cell(is_active)="data">
                <span class="badge px-3 py-1 rounded-pill"
                    :class="data.item.is_active ? 'bg-success text-white' : 'bg-danger text-white'">
                    {{ data.item.is_active ? $t('user.status_active') : $t('user.status_inactive') }}
                </span>
            </template>
        </CrudTable>
    </div>
</template>

<script>
import { request } from "@/Util/Request";
import CrudTable from "@/components/CrudTable.vue";

export default {
    name: 'CustomerList',
    components: { CrudTable },

    data() {
        return {
            isLoading: false,
            currentPage: 1,
            perPage: 10,
            sortBy: 'created_at',
            sortDesc: true,
            fields: [
                { key: 'full_name', label: this.$t('customer.table_header_customer'), sortable: true },
                { key: 'phone', label: this.$t('customer.table_header_phone'), sortable: true },
                { key: 'email', label: this.$t('customer.table_header_email'), sortable: true },
                { key: 'nationality', label: this.$t('customer.table_header_nationality'), sortable: true },
                { key: 'is_active', label: this.$t('customer.table_header_status'), sortable: true },
                { key: 'created_at', label: this.$t('customer.table_header_created_at'), sortable: true }
            ],
        }
    },
    methods: {
        async fetchLocations() {
            try {
                this.isLoading = true;
                const response = await request({
                    method: "get",
                    url: "admin/customers",
                    params: {
                        page: this.currentPage,
                        per_page: this.perPage,
                        sort_by: this.sortBy,
                        sort_direction: this.sortDesc ? 'desc' : 'asc',
                        search: this.filters.search || ''
                    }
                });

                this.locations = response.data.data || [];
                this.paginationInfo = {
                    from: response.data.meta?.from || 0,
                    to: response.data.meta?.to || 0,
                    total: response.data.meta?.total || 0
                };
            } catch (error) {
                console.error('Error fetching locations:', error);
                this.locations = [];
                this.paginationInfo = {
                    from: 0,
                    to: 0,
                    total: 0
                };
            } finally {
                this.isLoading = false;
            }
        },
        handleSearch(search) {
            this.filters.search = search;
            this.currentPage = 1;
            this.fetchLocations();
        },

        handleFilter(filter) {
            this.filters = { ...this.filters, ...filter };
            this.currentPage = 1;
            this.fetchLocations();
        },
    }
}
</script>
